// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__rp45_","buttons":"RemoveExpirationActionButtons_buttons__VVfCx"};